// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: 'AIzaSyCGLFEF1fm7vfiLNkjsSwsdwZbEWu4OC6Y',
	authDomain: 'sura-lider-positivo-evaluacion.firebaseapp.com',
	projectId: 'sura-lider-positivo-evaluacion',
	storageBucket: 'sura-lider-positivo-evaluacion.firebasestorage.app',
	messagingSenderId: '738645123800',
	appId: '1:738645123800:web:4891bad7421192f3dbedad',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
